/* tslint:disable */

import React from "react"

const FullscreenExitIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <path
          d="M7 24h5v5h3v-8H7v3zm5-12H7v3h8V7h-3v5zm9 17h3v-5h5v-3h-8v8zm3-17V7h-3v8h8v-3h-5z"
          fill="white"
        />
      </svg>
    </div>
  )
}

export default FullscreenExitIcon
